export const localStorageNewsName = 'multiple_bumps';
export const enabledIcon = false;
export const messageNewsIcon = '';
export const onlyUnity = false;
